import { GroupMemberLight, User } from 'src/app/user/model/user';

/** Maps API light user rows to {@link User} for staff pickers and group member grids. */
export function mapGroupMemberLightToUser(m: GroupMemberLight): User
{
  const display = m.name ?? m.fullName ?? '';
  const u = new User();
  u.id = m.id;
  u.firstName = m.firstName;
  u.lastName = m.lastName;
  u.name = display;
  u.fullName = display;
  u.username = m.username;
  u.userName = m.username;
  u.enabled = m.enabled;
  u.deleted = m.deleted;
  u.inRegistration = m.inRegistration ?? false;
  if (m.photo != null && m.photo !== '')
  {
    u.photo = m.photo;
  }
  return u;
}

export function mapGroupMemberLightsToUsers(members: GroupMemberLight[]): User[]
{
  return members.map(mapGroupMemberLightToUser);
}
